module.exports = __webpack_public_path__ + "img/digid.c696560d.png";